(() => {
  const CART_ENDPOINTS = [
    "/cart/add.js",
    "/cart/change.js",
    "/cart/update.js",
    "/cart/clear.js",
    "/cart.js",
  ];

  const isCartRequest = (url) => {
    if (!url) return false;
    try {
      const u = typeof url === "string" ? url : url.url || "";
      return CART_ENDPOINTS.some((p) => u.includes(p));
    } catch {
      return false;
    }
  };

  const debounce = (fn, wait = 120) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart fetch failed");
    return res.json();
  }

  function updatePromoEl(promoEl, itemCount) {
    const threshold = parseInt(promoEl.getAttribute("data-ow-b2-threshold") || "2", 10);
    const qty = Number(itemCount || 0);
    const remaining = Math.max(0, threshold - qty);

    // Update headline/subtext
    const titleEl = promoEl.querySelector("[data-ow-b2-title]");
    const textEl = promoEl.querySelector("[data-ow-b2-text]");

    if (qty >= threshold) {
      if (titleEl) titleEl.textContent = "Nice. You unlocked $10 off.";
      if (textEl) textEl.textContent = "Discount applies automatically at checkout.";
    } else {
      if (titleEl) titleEl.textContent = "Buy 2 items, get $10 off.";
      if (textEl) {
        textEl.innerHTML = `Add <strong>${remaining}</strong> more item${remaining === 1 ? "" : "s"} to unlock the discount.`;
      }
    }

    // Update boxes/icons/hints
    [1, 2].forEach((n) => {
      const box = promoEl.querySelector(`[data-ow-b2-box="${n}"]`);
      const icon = promoEl.querySelector(`[data-ow-b2-icon="${n}"]`);
      const hint = promoEl.querySelector(`[data-ow-b2-hint="${n}"]`);
      const on = qty >= n;

      if (box) box.classList.toggle("is-on", on);
      if (icon) icon.textContent = on ? "✓" : "×";

      if (hint) {
        if (n === 1) hint.textContent = on ? "Added" : "Add any item";
        if (n === 2) hint.textContent = on ? "$10 off unlocked" : "Add one more";
      }
    });

    promoEl.setAttribute("data-ow-b2-qty", String(qty));
  }

  const refreshAllPromos = debounce(async () => {
    const promos = document.querySelectorAll("[data-ow-b2-promo]");
    if (!promos.length) return;

    let cart;
    try {
      cart = await fetchCart();
    } catch {
      return;
    }

    promos.forEach((el) => updatePromoEl(el, cart.item_count));
  }, 120);

  // 1) Run once on load
  function init() {
    refreshAllPromos();

    // 2) Watch DOM changes (themes often re-render cart drawer HTML)
    const mo = new MutationObserver(() => refreshAllPromos());
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // 3) Intercept fetch to catch cart updates immediately
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const resp = await originalFetch.apply(this, args);
      try {
        const url = args?.[0];
        if (isCartRequest(url)) {
          // wait a tick for theme DOM updates, then refresh
          setTimeout(refreshAllPromos, 80);
        }
      } catch {}
      return resp;
    };

    // 4) Intercept XHR (some themes still use it)
    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__owCartUrl = url;
      return origOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      this.addEventListener(
        "load",
        () => {
          try {
            if (isCartRequest(this.__owCartUrl)) {
              setTimeout(refreshAllPromos, 80);
            }
          } catch {}
        },
        { once: true }
      );
      return origSend.apply(this, args);
    };

    // 5) As a fallback, update after clicks/changes (covers odd cases)
    document.addEventListener("click", () => setTimeout(refreshAllPromos, 120));
    document.addEventListener("change", () => setTimeout(refreshAllPromos, 120));
  }

  document.addEventListener("DOMContentLoaded", init);
})();
